<template>
  <div id="team" class="bottom-corner-background-img main-component-container">
      <v-card-title class="component-title">
          <img alt="AboutTitle" v-bind:src="require('@/assets/Staff.png')" class="component-title-image">
      </v-card-title>
      <div class="component-content">
        <div class="row">
          <div class="component-locale-text">
                <p v-for="(text, index) in $i18n.messages[$i18n.locale].staff.content" :key="index">{{ text }}</p>
                    <!--Refactor to take from extra json data import-->
                <p class="cont">Scenario Writers</p>
                <div class="row">
                  <div class="column">
                    <p class="name-cont">Meteora</p>

                  </div>

                    <div class="limiter">|</div>

                  <div class="column">
                    <p class="name-cont">SOLOMON</p>

                  </div>
                </div>

                <p class="cont">{{$i18n.messages[$i18n.locale].staff.l3Dart }}</p>
                <div class="row">
                  <div class="column">
                    <p class="name-cont">Cristal Gutierrez</p>
                    <div class="row sub fa-center">
                      <p class="fab fa-artstation"></p>
                      <p class="sub"><a href="https://www.artstation.com/cristalg" >Artstation</a></p>
                    </div>
                  </div>
                  <!--Second Column missing style-->
                </div>
                <p class="cont">{{$i18n.messages[$i18n.locale].staff.mChara }}</p>
                <div class="row">
                  <div class="column">
                    <p class="name-cont">Otake Okayu</p>
                    <p class="sub">@okyu22</p>
                  </div>
                  <!--Second Column missing style-->
                </div>

                <p class="cont">{{$i18n.messages[$i18n.locale].staff.mEnemy }}</p>
                <div class="row">
                  <div class="column">
                    <p class="name-cont">Maka Nyan</p>
                    <p class="sub">@maka_nyan_</p>
                  </div>

                </div>

                <p class="cont">{{$i18n.messages[$i18n.locale].staff.fPromoIll }}</p>
                <div class="row">
                  <div class="column">
                    <p class="name-cont">Maka Nyan</p>

                  </div>

                </div>
                <p class="cont">{{$i18n.messages[$i18n.locale].staff.chibiPromo }}</p>
                <div class="row">
                  <div class="column">
                    <p class="name-cont">Anini</p>
                      <p class="sub">@Anini_chu</p>
                  </div>
                </div>
                <p class="cont">{{$i18n.messages[$i18n.locale].staff.music }}</p>
                <div class="row">
                  <div class="column">
                    <p class="name-cont">Pedro Armando</p>
                    <div class="row sub fa-center">
                      <p class="fab fa-facebook-square"></p>
                      <p>Coventrate</p>
                    </div>


                  </div>

                </div>
              <br>
          </div>

        </div>
      </div>

  </div>
</template>

<script>
export default {
    name: 'Team',
    data () {
        return {

        }
    }
}
</script>

<style scoped>
.component-title-image{
  width: 650px;
}
.name-cont{
  margin-top: 5px;
    margin-bottom: 0px;
}
.sub{
  margin-bottom: 0px;
  font-size: 15px;
  -align-self: center;
}
.row .fa-center{
  align-items: center;
  gap: 0px !important;
  padding-left: 1rem;
}
.limiter{
  align-items:center;
  align-content: center;
margin-bottom: 0px;
padding-top: 3px;
}
.cont{
  -font-size: 20px;
  background-image: url('~@/assets/triangle.png');
  background-size: 1rem,auto;
  background-position: left center;
  padding-left: 1rem;
  font-weight: normal;
  margin-top: 10px;
  margin-bottom: 0px;
}
p  a{
  text-align: center;
  text-decoration: none;
  color: var(--unnamed-color-000000);
  border-bottom: none !important;

}
.column{
  gap: 0px;
}
.row{
  gap:10px;
}
</style>
